import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot, Resolve,
  RouterStateSnapshot
} from '@angular/router';
import { EMPTY, Observable, of } from 'rxjs';
import { mergeMap, take } from 'rxjs/operators';
 
import { TourneeModel } from '../models/tournee.model';
import { DataService } from '../services/data/data.service';
import { OrderService } from '../services/order/order.service';
import { SaleService } from '../services/sale/sale.service';
 
@Injectable({
  providedIn: 'root',
})

export class TourneeProducerResolverService implements Resolve<TourneeModel> {


  constructor(private dataService: DataService, private saleService: SaleService, private orderService: OrderService) {
  }
 
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<TourneeModel> | Observable<never> {
    const id = route.paramMap.get('tourneeId');
    const profileId = route.paramMap.get('profileId');
    const action = route.paramMap.get('action');

    // console.log(id);
    if(id == undefined){
      const date = new Date();
      date.setDate(date.getDate()+7);
      const dateIso = date.toISOString();
      const newItem = <TourneeModel>{
        status:'new',
        notificationStatus:'toBeNotified',
        producer:{
          key:profileId,
        },
        details:{
          paymentModes:[],
          datesPlaces:[{
            date:dateIso,
            geocoding:{
              address:{}
            },
            moment: 'morning',
            fromTimeHour:'08:00',
            toTimeHour:'12:00',
          }],
          format:'solo',
          currency:'EUR',
          recurrence:'weekly',
          frequency:1,
          deliveryType:'tournee',
          deliveryCost:0,
          productMode:'custom',
          autoAccept:false,
          directPrice:false,
          ordersVisible:false,
          commissionType:'none',
          commissionValue:0,
          fromTimeHour:'08:00',
          toTimeHour:'12:00',
          opening:6,
          openingTimeHour:'01:00',
          closing:1,
          closingTimeHour:'01:00',
          prePayment:'none',
          priceMode: 'VATIncluded'
        },
        finances:{
          orderCount:0,
          totals:{
            paid:0,
            sold:0
          }
        },
        orders:{},
        products:{
          freeText:'',
          references:{}
        },
        notifications:{
          config:['producer','sale','place'],
        }
      };
      return of(newItem);
    } else {
      return this.dataService.getTourneeProducer(id, profileId).pipe(
        take(1),
        mergeMap(item => {
          // console.log('tournee producer resolver',item)
          if (item) {
            if(action && action =='copy'){
              delete item.key;
              delete item.orders;
              delete item.statuses;
              delete item.market;
              delete item.finances;
              delete item.notifications?.consumers;
              delete item.notifications?.counter;
              const dates = this.saleService.getDatesPlaces(item.details);
              item.details.dates
              item.status = 'new';
              item.notificationStatus = 'toBeNotified';
              item.details.format = 'solo';
              item.details.nextDate = null;
              if(item.products && item.products.references){
                const productArray:any = Object.entries(item.products.references)
                for(const product of productArray){
                  if(product[1].stock){
                    item.products.references[product[0]].stock.current = item.products.references[product[0]].stock.initial;
                  }
                }
              }
              return of(item);
            }
            else{
              if(!item.orders){
                item.orders = {};
              }
              else{
                const orders:any[] = Object.values(item.orders)
                for(const order of orders){
                  order.tournee = {details: item.details};
                  this.orderService.convertOrderToDatePlaceSystem(order);
                }
              }
              // console.log(item);
              item.details.datesPlaces = this.saleService.getDatesPlaces(item.details);
              return of(item);
            }
          } else {// id not found
            return EMPTY;
          }
        })
      );
    }
  }
}